import DeliveryMethods from '../mixins/delivery-methods'
export default {
  methods: {
    /**
    * FAQ画面のリンクをドメイン毎に切り替える
    */
    getFAQViewInquiryLink () {
      if (DeliveryMethods.DOMAIN === 0) {
        return 'https://www.jmec.co.jp/contact/contact01/'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return 'https://cedge-inc.com/contacts/'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return 'https://contactym-inc.com/contacts/'
      }
      return ''
    },
    /**
    * チュートリアル動画のリンクをドメイン毎に切り替える
    */
    getTutorialVideo () {
      if (DeliveryMethods.DOMAIN === 0) {
        return 'https://player.vimeo.com/video/642567181?h=449a33552b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return 'https://player.vimeo.com/video/642567181?h=449a33552b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return 'https://player.vimeo.com/video/642567181?h=449a33552b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
      }
      return ''
    },
    /**
    * フッターのリンクをドメイン毎に切り替える
    */
    getFooterLink () {
      if (DeliveryMethods.DOMAIN === 0) {
        return 'https://jmec.co.jp/'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return 'https://cedge-inc.com/'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return 'https://contactym-inc.com'
      }
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/LinkUtil.js